<template>
  <div>
    <section class="section section-lg section-shaped overflow-hidden my-0">
      <div class="shape shape-style-1 shape-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container shape-container py-0 pb-5">
        <div class="row row-grid justify-content-between align-items-center">
          <div class="col-lg-6">
            <h4 class="display-4 text-white">Conoce mi Trabajo</h4>
            <p class="lead text-white">
              Mi trabajo se destaca por cumplir los requerimientos del cliente,
              puntualidad en su entrega y contar con una gran usabilidad y
              eficiencia. El uso de buenas prácticas y buen uso de las
              herramientas informáticas.
            </p>
          </div>
          <div class="col-lg-5 mb-lg-auto">
            <div class="transform-perspective-right">
              <div class="card border-0 shadow bg-secondary">
                <div class="card-header pb-5 bg-white">
                  <div class="text-muted text-center mb-3">
                    <small>Puedes mirar otros proyectos aquí</small>
                  </div>
                  <div class="btn-wrapper text-center">
                    <button type="button" class="btn btn-icon btn-neutral">
                      <span class="btn-inner--icon">
                        <img src="../assets/img/git.png" />
                      </span>
                      <span class="btn-inner--text">Github</span>
                    </button>
                  </div>
                </div>
                <div class="card-body px-lg-5 py-lg-5">
                  <div class="text-center text-muted mb-4">
                    <small class="text-white" style="font-size: 1em"
                      >Dejame tu mensaje</small
                    >
                  </div>
                  <form role="form">
                    <div class="form-group input-group input-group-alternative">
                      <input
                        aria-describedby="addon-right addon-left"
                        placeholder="Nombre Completo"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group input-group input-group-alternative">
                      <input
                        aria-describedby="addon-right addon-left"
                        placeholder="Correo Electrónico"
                        class="form-control"
                      />
                    </div>
                    <div class="text-center">
                      <button type="button" class="btn my-4 btn-primary">
                        Contáctame
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <div class="card carta card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div>
                      <img src="../assets/img/gipi.png" class="img-fluid" alt />
                    </div>
                    <br />
                    <h6 class="text-primary text-uppercase">GipiCorg</h6>
                    <p class="description mt-3">Sistema web (Angular 8).</p>
                    <p class="description mt-1">
                      Sistema enfocado en el gestión, rastreo y envió de
                      paquetes.
                    </p>
                    <div>
                      <span class="badge badge-pill badge-danger"
                        >Angular 8</span
                      >
                      <span class="badge badge-pill badge-primary"
                        >BOOTSTRAP</span
                      >
                    </div>
                    <button
                      disabled="disabled"
                      class="btn btn-primary mt-4 text-white"
                    >
                      Sistema privado
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="card carta card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div>
                      <img
                        src="../assets/img/paseo.jpg"
                        class="img-fluid"
                        alt
                      />
                    </div>
                    <br />
                    <h6 class="text-primary text-uppercase">
                      De Paseoh Viajes y Turismo
                    </h6>
                    <p class="description mt-3">
                      Sistema y portal web para agencia de turismo; sistema
                      administrativo para la gestión de viajes
                    </p>
                    <div>
                      <span class="badge badge-pill badge-danger">LARAVEL</span>
                      <span class="badge badge-pill badge-primary"
                        >BOOTSTRAP</span
                      >
                      <span class="badge badge-pill badge-warning text-white"
                        >JavaScript</span
                      >
                    </div>
                    <a
                      href="https://www.depaseohviajesyturismo.com/"
                      target="_blank"
                      class="btn btn-primary mt-4"
                      >Conócelo</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="card carta card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div>
                      <img
                        src="../assets/img/quiro.png"
                        class="img-fluid"
                        alt
                      />
                    </div>
                    <br />
                    <h6 class="text-primary text-uppercase">
                      Salud y Quiropraxia Ipiales
                    </h6>
                    <p class="description mt-3">
                      Sistema web para gestionr pacientes, historias clinicas,
                      agendar citas e información de ganancias. Sistema
                      desarrollador en Laravel 9 y Angular 12..
                    </p>
                    <div>
                      <span class="badge badge-pill badge-danger">LARAVEL</span>
                      <span class="badge badge-pill badge-primary"
                        >BOOTSTRAP</span
                      >
                      <span class="badge badge-pill badge-danger text-white"
                        >Angular</span
                      >
                    </div>
                    <button
                      disabled="disabled"
                      class="btn btn-primary mt-4 text-white"
                    >
                      Sistema privado
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row row-grid">
              <div class="col-lg-4">
                <div class="card carta card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div>
                      <img
                        src="../assets/img/somac.jpg"
                        class="img-fluid"
                        alt
                      />
                    </div>
                    <br />
                    <h6 class="text-primary text-uppercase">SOMAC CONTABLE</h6>
                    <p class="description mt-3">
                      Sistema Contable empresas públicas y privadas con
                      funcionalidades como: Catálogo PUC, personas naturales,
                      jurídicas, empleados, consorcios, centro de costos,
                      retenciones y descuentos, generación de reportes, exporte
                      e importe Excel.
                    </p>
                    <div>
                      <span class="badge badge-pill badge-danger">LARAVEL</span>
                      <span class="badge badge-pill badge-primary"
                        >BOOTSTRAP</span
                      >
                      <span class="badge badge-pill badge-warning text-white"
                        >JavaScript</span
                      >
                    </div>
                    <button
                      disabled="disabled"
                      class="btn btn-primary mt-4 text-white"
                    >
                      Sistema privado
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="card carta card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div>
                      <img
                        src="../assets/img/lectorami.png"
                        class="img-fluid"
                        alt
                      />
                    </div>
                    <br />
                    <h6 class="text-primary text-uppercase">Leactor AMI CRM</h6>
                    <p class="description mt-3">
                      Sistema para el control de clientes, gestión de empleados,
                      envió de correos electrónicos, gestión de contratos,
                      plantillas de emails, generación de reportes, exporte e
                      importe Excel y sistema de roles.
                    </p>
                    <div>
                      <span class="badge badge-pill badge-danger">LARAVEL</span>
                      <span class="badge badge-pill badge-primary"
                        >BOOTSTRAP</span
                      >
                      <span class="badge badge-pill badge-warning text-white"
                        >JavaScript</span
                      >
                    </div>
                    <button
                      disabled="disabled"
                      class="btn btn-primary mt-4 text-white"
                    >
                      Sistema privado
                    </button>
                    <a
                      href="https://marketing.lectorami.co/"
                      target="_blank"
                      class="btn btn-primary mt-4"
                      >Portal web</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="card carta card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div>
                      <img
                        src="../assets/img/cargalo.png"
                        class="img-fluid"
                        alt
                      />
                    </div>
                    <br />
                    <h6 class="text-primary text-uppercase">
                      CARGALO COLOMBIA
                    </h6>
                    <p class="description mt-3">
                      Portal web para conocer y descargar app movil para gestion
                      de alquirer de transportes de carga.
                    </p>
                    <div>
                      <span class="badge badge-pill badge-primary"
                        >BOOTSTRAP</span
                      >
                      <span class="badge badge-pill badge-danger text-white"
                        >Angular</span
                      >
                    </div>
                    <a
                      href="https://cargalocolombia.com/"
                      target="_blank"
                      class="btn btn-primary mt-4"
                      >Conócelo</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5" style="justify-content: center">
              <button
                class="btn btn-primary"
                type="button"
                data-toggle="collapse"
                data-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                Ver más
              </button>
            </div>
            <div class="collapse" id="collapseExample">
              <div class="row row-grid mt-5">
                <div class="col-lg-4">
                  <div class="card carta card-lift--hover shadow border-0">
                    <div class="card-body py-5">
                      <div>
                        <img
                          src="../assets/img/waff.png"
                          class="img-fluid"
                          alt
                        />
                      </div>
                      <br />
                      <h6 class="text-primary text-uppercase">WaffCake CRM</h6>
                      <p class="description mt-3">
                        Sistema para el control de clientes, sistema de cliente
                        frecuente, sistema de clientes referidos, generación de
                        reportes, exporte e importe Excel y sistema de roles.
                      </p>
                      <div>
                        <span class="badge badge-pill badge-danger"
                          >LARAVEL</span
                        >
                        <span class="badge badge-pill badge-primary"
                          >BOOTSTRAP</span
                        >
                        <span class="badge badge-pill badge-warning text-white"
                          >JavaScript</span
                        >
                      </div>
                      <button
                        disabled="disabled"
                        class="btn btn-primary mt-4 text-white"
                      >
                        Sistema privado
                      </button>
                      <a
                        href="https://www.waffcake.com/"
                        target="_blank"
                        class="btn btn-primary mt-4"
                        >Portal web</a
                      >
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card carta card-lift--hover shadow border-0">
                    <div class="card-body py-5">
                      <div>
                        <img
                          src="../assets/img/altamira.png"
                          class="img-fluid"
                          alt
                        />
                      </div>
                      <br />
                      <h6 class="text-primary text-uppercase">JAC Altamira</h6>
                      <p class="description mt-3">
                        Sistema para el control de ingresos y egresos de
                        conjunto residencial, control de roles, reportes, video
                        llamadas directas con Zoom y registro de habitantes.
                      </p>
                      <div>
                        <span class="badge badge-pill badge-danger"
                          >LARAVEL</span
                        >
                        <span class="badge badge-pill badge-primary"
                          >BOOTSTRAP</span
                        >
                        <span class="badge badge-pill badge-success">Vue</span>
                      </div>
                      <button
                        disabled="disabled"
                        class="btn btn-primary mt-4 text-white"
                      >
                        Sistema privado
                      </button>
                      <br />
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card carta card-lift--hover shadow border-0">
                    <div class="card-body py-5">
                      <div>
                        <img
                          src="../assets/img/mareto.png"
                          class="img-fluid"
                          alt
                        />
                      </div>
                      <br />
                      <h6 class="text-primary text-uppercase">
                        Mareto Plaza CRM
                      </h6>
                      <p class="description mt-3">
                        Sistema para el control de estudiantes, gestión de
                        empleados, envió de correos electrónicos, gestión de
                        contratos, plantillas de emails, generación de reportes,
                        exporte e importe Excel y sistema de roles.
                      </p>
                      <div>
                        <span class="badge badge-pill badge-danger"
                          >LARAVEL</span
                        >
                        <span class="badge badge-pill badge-primary"
                          >BOOTSTRAP</span
                        >
                        <span class="badge badge-pill badge-warning text-white"
                          >JavaScript</span
                        >
                      </div>
                      <button
                        disabled="disabled"
                        class="btn btn-primary mt-4 text-white"
                      >
                        Sistema privado
                      </button>
                      <a
                        href="https://www.maretoplaza.com/"
                        target="_blank"
                        class="btn btn-primary mt-4"
                        >Portal web</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row row-grid">
                <div class="col-lg-4">
                  <div class="card carta card-lift--hover shadow border-0">
                    <div class="card-body py-5">
                      <div>
                        <img
                          src="../assets/img/sio.png"
                          class="img-fluid"
                          alt
                        />
                      </div>
                      <br />
                      <h6 class="text-primary text-uppercase">SIO</h6>
                      <p class="description mt-3">
                        Sistema web para el SENA. Software desarrollado para la
                        gestión nóminas, funcionarios, aprendices, ambientes,
                        generación de reportes, sistemas de roles
                      </p>
                      <div>
                        <span class="badge badge-pill badge-danger"
                          >LARAVEL</span
                        >
                        <span class="badge badge-pill badge-primary"
                          >BOOTSTRAP</span
                        >
                        <span class="badge badge-pill badge-warning text-white"
                          >JavaScript</span
                        >
                      </div>
                      <button
                        disabled="disabled"
                        class="btn btn-primary mt-4 text-white"
                      >
                        Sistema privado
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "trabajo",
  data() {
    return {};
  },
};
</script>